export default "__VITE_ASSET__32c94607__"